import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function ServerDatabaseFail({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M5.5 9.5C5.5 5.902 8.4 3 12 3C15.59 3 18.5 5.9 18.5 9.5M5.5 9.5C5.5 13.09 8.4 16 12 16C15.59 16 18.5 13.09 18.5 9.5M5.5 9.5H18.5M10.5 18.5L13.5 21.5M10.5 21.5L13.5 18.5M16 20H20M4 20H8M10.677 3.765C8.587 7.25 8.587 11.745 10.677 15.235C11.287 16.255 12.707 16.255 13.317 15.235C15.397 11.745 15.397 7.25 13.317 3.765C12.697 2.745 11.277 2.745 10.667 3.764L10.677 3.765Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default ServerDatabaseFail;